/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated.js';
import { addDependencies } from './dependenciesAdd.generated.js';
import { conjDependencies } from './dependenciesConj.generated.js';
import { ctransposeDependencies } from './dependenciesCtranspose.generated.js';
import { eigsDependencies } from './dependenciesEigs.generated.js';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated.js';
import { largerDependencies } from './dependenciesLarger.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { powDependencies } from './dependenciesPow.generated.js';
import { smallerDependencies } from './dependenciesSmaller.generated.js';
import { sqrtDependencies } from './dependenciesSqrt.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createNorm } from '../../factoriesAny.js';
export var normDependencies = {
  absDependencies,
  addDependencies,
  conjDependencies,
  ctransposeDependencies,
  eigsDependencies,
  equalScalarDependencies,
  largerDependencies,
  matrixDependencies,
  multiplyDependencies,
  powDependencies,
  smallerDependencies,
  sqrtDependencies,
  typedDependencies,
  createNorm
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesNorm.generated.js
// module id = 368
// module chunks = 2